import { render, staticRenderFns } from "./modalBoleto.vue?vue&type=template&id=8ff63942&scoped=true&"
import script from "./modalBoleto.vue?vue&type=script&lang=js&"
export * from "./modalBoleto.vue?vue&type=script&lang=js&"
import style0 from "./modalBoleto.vue?vue&type=style&index=0&id=8ff63942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff63942",
  null
  
)

export default component.exports